import React from 'react';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends React.Component {
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            const rootElement = document.getElementById('root');
            rootElement.classList.contains('menu-floating') && rootElement.classList.remove('menu-floating')
            window.scrollTo(0, 0)
        }
    }
  
    render() {
        return this.props.children
    }
}
  
export default withRouter(ScrollToTop)